const projectCreator = {
  path: 'project-creator', //办公室
  component: () => import("@/views/member/project-creator/project-creator"),
  meta: {
    tabBar: 'home'
  },
  children:[
    {
      //学习库
      path: 'study-house',
      component: () => import("@/views/member/project-creator/study-house"),
    },
    {
      //视频详情
      path: 'study-details',
      component: () => import("@/views/member/project-creator/study-details"),
    },
    {
      //数据统计
      path: 'data-info',
      component: () => import("@/views/member/project-creator/data-info"),
    },
    {
      //项目赠品管理
      path: 'gift-manage',
      component: () => import("@/views/member/project-creator/gift-manage"),
    },
    {
      //项目赠品明细
      path: 'gift-detail',
      component: () => import("@/views/member/project-creator/gift-detail"),
    },
    {
      //分享会员列表
      path: 'study-list',
      component: () => import("@/views/member/project-creator/study-list"),
    },
  ]
};

export default projectCreator;